import { UserRoleEnum } from '@enums/user-role.enum';
import { CHECK_LIST_DETAILS_EDITABLE_ROLES } from '@modals/check-list-details/properties/check-list-details-modal.properties';

/**
 * Returns whether the current role can toggle and save checklist completion.
 *
 * @param role - current user role
 */
export function isCheckListDetailsEditable(role: string | null | undefined): boolean {
  return CHECK_LIST_DETAILS_EDITABLE_ROLES.includes(role as UserRoleEnum);
}
